<div class="expandable-item-header" (click)="$event.stopPropagation(); expanded.set(!expanded())">
  <ng-content select="[expandable-item-title]"></ng-content>
  <lucide-icon [name]="expanded() ? 'chevron-up' : 'chevron-down'" [size]="16" [strokeWidth]="1.5" />
</div>
<div [class.hidden]="!expanded()" class="expandable-item-content">
  <ng-content></ng-content>
</div>
